<template>
  <div
    v-if="!hideMe"
    :class="{'spl-parcel-detail-block-vertical': vertical, 'spl-parcel-detail-block-error': error, 'spl-parcel-detail-block-editing': isEditing}"
    class="spl-parcel-detail-block">
    <div class="spl-parcel-detail-block__label">
      {{ label }}
    </div>
    <div
      v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.UPDATE)"
      :class="{'spl-parcel-detail-block__edit-open': isEditing}"
      class="spl-parcel-detail-block__edit"
      @click="toggleEditable" />

    <!-- *********************** Body of the block *********************************** -->
    <div class="spl-parcel-detail-block__body">
      <!-- *********************** Block with all fields *********************************** -->
      <div
        v-for="(item, index) in blockContent"
        :key="'parcelDetailReferences' + index"
        :class="{'spl-parcel-detail-block__body__content-blocks': contentBlocks, 'spl-parcel-detail-block__body__content-edit': isEditing}"
        class="spl-parcel-detail-block__body__content">
        <!-- ***********************Field Labels *********************************** -->
        <div
          v-show="item.Visible || item.value !== ''"
          v-if="isEditing || item.value !== ''"
          class="spl-parcel-detail-block__body__content__label">
          {{ item.field_label }}
        </div>
        <!-- *********************** Fields in View Mode *********************************** -->
        <div v-if="(!isEditing && item.value !== '') || !item.editable" class="spl-parcel-detail-block__body__content__value spl-parcel-detail-block__body__content__value-pre">
          {{ item.value }}
        </div>
        <!-- *********************** Fields in Edit  Mode *********************************** -->
        <div
          v-show="item.Visible || item.value !== ''"
          v-if="isEditing && item.editable"
          class="spl-parcel-detail-block__body__content__value">
          <!-- *********************** Input  Fields *********************************** -->
          <form-input
            :value="item.value"
            :index="index"
            @input="updateItemValue" />
        </div>
      </div>

      <div v-if="isEditing" class="row">
        <div class="col6">
          <form-button
            wide="true"
            secondary="true"
            @onClick="close">
            Cancel
          </form-button>
        </div>
        <div class="col6">
          <form-button
            :disabled="saving"
            wide="true"
            @onClick="save">Save</form-button>
        </div>
      </div>
    </div>
    <div v-if="highlight" class="spl-parcel-detail-block__highlight">
      {{ highlight }}
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import webApi from '@/webApi'
import constants from '@/constants'
import { mapActions } from 'vuex'
export default {
  name: 'ParcelDetailBlock',
  mixins: [Helpers],
  props: [
    'label',
    'highlight',
    'error',
    'content',
    'contentBlocks',
    'vertical',
    'originalParcelJson',
    'editInProgress'
  ],
  data () {
    return {
      isEditing: false,
      tempBlockContent: this.cloneArray(this.content),
      changedValueIndices: [],
      constants,
      hideMe: false,
      saving: false
    }
  },
  computed: {
    blockContent () {
      this.getProfiler()
      return this.content
    },
    parcel_json () {
      return this.originalParcelJson
    }
  },
  methods: {
    ...mapActions('profiler', ['loadProfiler']),
    getProfiler () {
      var customer_id = this.originalParcelJson.Customer_ID
      var country_id = this.originalParcelJson.Country_ID
      var is_forward = this.originalParcelJson.Is_Forward
      var profileFilter = { Customer_ID: customer_id, Country_ID: country_id, Is_Forward: is_forward }
      this.loadProfiler(profileFilter).then(() => {
        this.profileData = JSON.parse(window.sessionStorage.getItem('Profiler_List'))
        this.content.forEach(reference => {
          if (this.profileData !== null && this.profileData.Fields.length > 0) {
            const found = this.profileData.Fields.find(el => el.Name.toLowerCase() === reference.field_label.toLowerCase())
            if (found) {
              reference.Visible = found.Visible
            } else {
              reference.Visible = true
            }
          } else {
            reference.Visible = true
          }
        })
        this.$forceUpdate()
      }).catch((error) => {
        window.bus.$emit('openErrorModal', error.ExceptionMessage)
      })
    },
    close () {
      this.isEditing = false
      window.bus.$emit('edit_in_progress')
    },

    // ************************ Toogle  Editable ************************
    // Changes to edit mode or closes it again. Edit mode is only possible if
    // not already another component is in edit mode
    toggleEditable () {
      // Close the edit mode
      if (this.isEditing) {
        this.close()
      } else {
        // Open the edit mode if not another component is in editing
        if (this.editInProgress) {
          window.bus.$emit('openWarningModal', 'You can only update one section at the same time. Please close the other one to edit here.')
        } else {
          this.isEditing = true
          window.bus.$emit('edit_in_progress')
        }
      }
    },

    updateItemValue (inputValue, index) {
      // Update the value for dropdowns, then take also the label
      this.changedValueIndices.push({ changed_index: index })
      if (inputValue.label) {
        this.$set(this.tempBlockContent[index], 'label', inputValue.label)
        this.$set(this.tempBlockContent[index], 'value', inputValue.value)
      } else {
        // Input fields we take the value 1:1
        this.$set(this.tempBlockContent[index], 'value', inputValue)
      }
    },

    // Checks which fields were updated and
    save () {
      this.saving = true
      // Check if something was changed
      this.get_Changed_Parcel(this,
        // Success function which returns if something was changed and updated parcel_json
        function (context, parcelUpdated, tempParcelJson) {
          // Check if an update happend
          if (parcelUpdated) {
            // call update parcel web API
            // Call the api and pass the filtered columns and values
            webApi.parcel.update_Parcel(tempParcelJson).then((response) => {
              // Parcel was succesfully updated so we update the blockContent
              context.changedValueIndices.forEach(item => {
                if (context.tempBlockContent[item.changed_index].label) {
                  context.$set(context.blockContent[item.changed_index], 'label', context.tempBlockContent[item.changed_index].label)
                }
                context.$set(context.blockContent[item.changed_index], 'value', context.tempBlockContent[item.changed_index].value)
              })
              context.$toast('The parcel got updated with your changes', constants.defaultToastOptions())
              context.$emit('parcelUpdated')
              context.isEditing = false
              context.saving = false
              window.bus.$emit('edit_in_progress')
            }).catch((response) => {
              window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
              context.saving = false
            })
            // update the modal with the new information
          } else {
            // Nothing was changed, so throw a warning
            window.bus.$emit('openWarningModal', "Didn't you forget something? Nothing was changed.")
            context.saving = false
          }
        },
        function () {
          window.bus.$emit('openErrorModal', 'Please try again.')
        })
    },

    // Checks if something was changed  in the block and returns updated parcel_json
    get_Changed_Parcel (context, successFunction, errorFunction) {
      // Copy the parcel
      var tempParcelJson = context.cloneArray(context.parcel_json)
      // Loop the content to get all changed fields
      let parcelUpdated = false

      context.tempBlockContent.forEach(item => {
        var foundReferenceIndex = tempParcelJson.References.findIndex(function (reference) {
          return reference.Reference_Type === item.field_label
        })
        // Check each reference
        if (foundReferenceIndex >= 0) {
          if (item.value !== tempParcelJson.References[foundReferenceIndex].Reference_Text) {
            parcelUpdated = true
            tempParcelJson.References[foundReferenceIndex].Reference_Text = item.value
          }
        }
      })
      // Return the succes function
      successFunction(context, parcelUpdated, tempParcelJson)
    }

  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-parcel-detail-block {
        background-color: $parcelTimelineBackgroundColor;
        margin-bottom: 20px;
        padding: 20px 17px 30px 17px;
        position: relative;
        width: 100%;

        @include mobile() {
            padding-bottom: 20px;
        }
        &-error {
            background-color: $redBackgroundLight;
            border-left: 2px solid $red;

            .spl-parcel-detail-block__edit {
                background-image: url(../../assets/icon-tripple-dot-red.svg);

            }
        }
        &-error &__edit {
            &-open {
                background-image: url(../../assets/icon-close-red.svg);
            }
        }
        &-vertical {
            &:after {
                clear: both;
                content: '';
                display: block;
                float: none;
            }
            .spl-parcel-detail-block {
                &__label,
                &__body {
                    float: left;
                    min-height: 10px;
                    vertical-align: top;
                }
                &__label {
                    width: 16.6667%;

                    @include mobile() {
                        width: 100%;
                    }
                }
                &__body {
                    width: 41.6667%;

                    @include mobile() {
                        width: 100%;
                    }
                }
            }
        }
        &__edit {
            background-image: url(../../assets/icon-tripple-dot.svg);
            background-position: center center;
            background-repeat: no-repeat;
            cursor: pointer;
            height: 25px;
            position: absolute;
            right: 10px;
            top: 20px;
            transition: opacity $shortTransition ease-in-out;
            width: 25px;

            &:hover {
                opacity: 0.5;
            }
            &-open {
                background-image: url(../../assets/icon-close.svg);
            }
        }
        &__label {
            color: $mainInputColor;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 15px;
        }
        &__body {
            .spl-button,
            .spl-textarea,
            .spl-dropdown {
                margin: 0 0 10px 0;
            }
            &__content {
                font-size: 12px;
                line-height: 1.7;

                &:after {
                    clear: both;
                    content: '';
                    display: block;
                    float: none;
                }
                &-blocks,
                &-edit {
                    margin-bottom: -20px;

                    .spl-parcel-detail-block__body__content {
                        &__label,
                        &__value {
                            width: 100%;
                        }
                        &__value {
                            margin-bottom: 220px;
                        }
                    }
                }
                &-edit .spl-parcel-detail-block__body__content {
                    &__label {
                        color: $parcelDetailBlockLabelColor;
                        font-family: $mono;
                        font-size: 9px;
                        font-weight: 700;
                        line-height: 12px;
                        letter-spacing: 1px;
                        margin-bottom: 10px;
                        text-transform: uppercase;
                    }
                    &__value {
                        .spl-input {
                            margin-bottom: 10px;
                        }
                    }
                }
                &__label,
                &__value {
                    float: left;
                    min-height: 10px;
                    vertical-align: top;
                    width: 50%;

                    @include mobile() {
                        width: 100%;
                    }
                }
                &__value {
                    font-weight: 600;

                    &-pre {
                        white-space: pre;
                    }
                    @include mobile() {
                        margin-bottom: 10px;
                    }
                }
            }
        }
        &__function-button {
            color: $middleYellow;
            cursor: pointer;
            display: inline-block;
            font-size: 12px;
            font-weight: 600;
            margin-right: 20px;
            transition: color $shortTransition ease-in-out;

            @include mobile() {
                margin-right: 10px;
            }
            &:hover {
                color: $yellowButtonLabelHover;
            }
        }
        &__highlight {
            background-color: $tableRowBackgroundColorSelected;
            border-left: 2px solid $middleYellow;
            bottom: 0;
            color: $mainInputColor;
            font-size: 12px;
            font-weight: 400;
            margin: 30px -17px -30px -17px;
            padding: 15px;
        }
    }
</style>
